import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import Bugsnag from "@bugsnag/js";
import BugsnagPerformance from "@bugsnag/browser-performance";
import { CognitoRequestError } from "./app/core/services/auth.service";

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
  enableProdMode();
}

Bugsnag.start({
  apiKey: environment.bugsnagApiKey,
  releaseStage: environment.envName,
  onError: event => {
    const error = event.originalError;
    if (error instanceof CognitoRequestError) {
      event.addMetadata('cognito', {
        operation: error.operation,
        errorType: error.errorType,
        status: error.status,
        requestId: error.requestId
      });
    }
  }
});

BugsnagPerformance.start({
  apiKey: environment.bugsnagApiKey,
  releaseStage: environment.envName,
  attributeStringValueLimit: 5000
});

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch(err => console.log(err));
